import type { RecordingDeviceCategory, RecordingMicrophoneType } from './recording-device-metadata';

export type RecordingDeviceCopy = {
  categoryLabel: string;
  categoryPlaceholder: string;
  microphoneLabel: string;
  microphonePlaceholder: string;
  detailsLabel: string;
  detailsPlaceholder: string;
  detailsRequired: string;
  deviceValues: Record<RecordingDeviceCategory, string>;
  microphoneValues: Record<RecordingMicrophoneType, string>;
};

export const recordingDeviceCopy: Record<'fr' | 'en', RecordingDeviceCopy> = {
  fr: {
    categoryLabel: "Appareil utilisé pour l'enregistrement",
    categoryPlaceholder: "Choisir l'appareil",
    microphoneLabel: 'Microphone utilisé',
    microphonePlaceholder: 'Choisir le microphone',
    detailsLabel: 'Précisez le matériel',
    detailsPlaceholder: 'Ex. : tablette de marque X, micro USB',
    detailsRequired: 'Précisez le matériel (2 à 80 caractères).',
    deviceValues: {
      smartphone: 'Téléphone',
      tablet: 'Tablette',
      computer: 'Ordinateur',
      digital_recorder: 'Enregistreur numérique',
      camera: 'Caméra',
      other: 'Autre appareil',
      unknown: 'Je ne sais pas',
    },
    microphoneValues: {
      built_in: 'Microphone intégré',
      wired_lavalier: 'Micro cravate filaire',
      wireless_lavalier: 'Micro cravate sans fil',
      headset: 'Micro-casque',
      external_handheld: 'Microphone externe à main',
      external_directional: 'Microphone externe directionnel',
      other_external: 'Autre microphone externe',
      unknown: 'Je ne sais pas',
    },
  },
  en: {
    categoryLabel: 'Recording device',
    categoryPlaceholder: 'Choose a device',
    microphoneLabel: 'Microphone used',
    microphonePlaceholder: 'Choose a microphone',
    detailsLabel: 'Describe the equipment',
    detailsPlaceholder: 'E.g. branded tablet, USB microphone',
    detailsRequired: 'Describe the equipment (2 to 80 characters).',
    deviceValues: {
      smartphone: 'Phone',
      tablet: 'Tablet',
      computer: 'Computer',
      digital_recorder: 'Digital recorder',
      camera: 'Camera',
      other: 'Other device',
      unknown: "I don't know",
    },
    microphoneValues: {
      built_in: 'Built-in microphone',
      wired_lavalier: 'Wired lavalier microphone',
      wireless_lavalier: 'Wireless lavalier microphone',
      headset: 'Headset microphone',
      external_handheld: 'External handheld microphone',
      external_directional: 'External directional microphone',
      other_external: 'Other external microphone',
      unknown: "I don't know",
    },
  },
};
